module.exports = __webpack_public_path__ + "static/media/vanity_url.ad0ec62d.jpg";